import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import auth from 'helpers/auth';
import PageContainer from '../../layout/PageContainer';
import CorredorGarantiaDetailBasicInfo from './CorredorGarantiaDetailBasicInfo';
import { API, BASE_URL } from '../../../CONST';
import CorredorGarantiaDetailMovimientos from './CorredorGarantiaDetailMovimientos';

const CorredorGarantiaDetail = ({ match: { params: { id } } }) => {
  const [ policy, setPolicy ] = useState(null);

  useEffect(() => {
    const url = `${BASE_URL}${API.garantiaIntermediario}/${id}`;
    auth.fetch(url).then(response => {
      setPolicy(response);
    });
  }, [id]);

  return (
    <PageContainer
      breadcrumbs={[
        { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
        {id: 1, name: 'CORREDOR', url: '/corredor/polizas-garantia' },
        {id: 2, name: 'PÓLIZAS GARANTÍA', url: '/corredor/polizas-garantia' },
        {id: 3, name: 'DETALLE PÓLIZA'},
      ]}
      returnTo={policy ? '/corredor/polizas-garantia/' : '/'}
    >
      <CorredorGarantiaDetailMovimientos policy={policy} />
      <CorredorGarantiaDetailBasicInfo policy={policy} />
    </PageContainer>
  );
};

CorredorGarantiaDetail.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

export default CorredorGarantiaDetail;
